/* @flow */

import React from 'react';
import EditoApp from 'edito/App';
import HeaderForm from './components/HeaderForm';

type Props = {
  content: CatalogPageContent,
  onSerialize?: (content: CatalogPageContent) => void,
};

const Edit = ({ content, onSerialize }: Props) => {
  const serialize = blocks => {
    onSerialize({
      ...content,
      blocks,
    });
  };

  const headerChanged = header =>
    onSerialize({
      ...content,
      ...header,
    });

  return (
    <div>
      <HeaderForm
        header={content}
        strategy={content._imageResourceStrategy}
        onUpdate={headerChanged}
      />
      <EditoApp
        fetchTemplatesUrl="/catalog/flow/templates.json"
        mode="draft"
        blocks={content.blocks || []}
        onUpdate={serialize}
      />
    </div>
  );
};

export default Edit;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/flow/simple/Edit.js